import styled from 'styled-components'
import BaseModal from '../BaseModal'

export const BaseModalContainer = styled(BaseModal)`
  overflow: scroll;
`



// WEBPACK FOOTER //
// ./src/components/Modals/PaymentModal/styles.tsx